import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/Footer";

export default function DashboardLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="h-full flex flex-col flex-1 ">
        {children}
      </main>
      <Footer />
    </div>
  );
}
